// extracted by mini-css-extract-plugin
export var locationCard = "_fp-0";